import { render, staticRenderFns } from "./current-assessment-tab.component.vue?vue&type=template&id=b7d639b0&"
import script from "./current-assessment-tab.component.vue?vue&type=script&lang=ts&"
export * from "./current-assessment-tab.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports